import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalBaseComponent } from '../add-or-edit-org-modal/modal-base.component';
import { CertificateEmail } from '../data/certificate-email';
import { DataService } from '../data/data.service';

@Component({
  selector: 'app-email-certificate-modal',
  templateUrl: './email-certificate-modal.component.html',
  styleUrls: ['./email-certificate-modal.component.css']
})
export class EmailCertificateModalComponent extends ModalBaseComponent<CertificateEmail> implements OnInit {

  constructor(modalService: NgbModal, dataService: DataService) { super(modalService, dataService); }

  rawRecipients: string;

  initializeNewData(): void {
    this.data.recipients = [];
    this.rawRecipients = "";
    this.data.body = "Your student has completed another milestone in Joy School English!";
    this.submitButtonText = "Send";
  }
  isInputValid(): boolean {
    return (
      this.data.subject && 
      this.data.certificateBase64 && 
      this.data.certificateName &&
      this.data.recipients && this.data.recipients.length > 0 );
  }
  saveEdit(): void {
    throw new Error('Editing sent emails not possible.');
  }
  saveNew(): void {
    this.isWaiting = true;
    this.dataService.sendCertificateEmail(this.data).subscribe(o => this.saveComplete(undefined));
  }

  addAttachment(attachmentName: string, attachmentBase64: string) {
    this.data.certificateName = attachmentName;
    this.data.certificateBase64 = attachmentBase64;
    this.data.subject = attachmentName;
  }

  separateRecipients() {
    this.data.recipients = this.rawRecipients.split(",").map(email => email.trim());
  }

  ngOnInit() {
    this.data = {
      recipients: [],
      subject: "",
      body: "",
      certificateBase64: "",
      certificateName: ""
    };
    this.modalHeader = "Email Certificate";
  }

}
